import { createTrackedAxiosInstance } from './apiInterceptor';
import { attachBearerAuthInterceptor } from './authenticatedApiClient';

// Auth API: use REACT_APP_AUTH_API_BASE_URL or default. When REACT_APP_USE_PROXY=true, use '' so the host proxies /api/auth to HTTP backend.
const useProxy = process.env.REACT_APP_USE_PROXY === 'true';
const rawAuthBase = process.env.REACT_APP_AUTH_API_BASE_URL;
const AUTH_BASE = useProxy
  ? ''
  : typeof rawAuthBase === 'string' && rawAuthBase.trim()
    ? rawAuthBase.trim()
    : '';
const API_BASE_URL = AUTH_BASE ? `${AUTH_BASE}/api/auth` : '/api/auth';

const apiClient = createTrackedAxiosInstance({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Login/signup do not require a token; do not redirect to login on 401 from auth routes.
attachBearerAuthInterceptor(apiClient, { requireAuth: false });

export const authService = {
  async login(credentials) {
    try {
      const response = await apiClient.post('/login', credentials);
      return {
        success: response.data.success,
        data: response.data,
        error: response.data.error,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Login failed',
      };
    }
  },

  async signup(userData) {
    try {
      const response = await apiClient.post('/signup', userData);
      return {
        success: response.data.success,
        data: response.data,
        error: response.data.error,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Signup failed',
      };
    }
  },

  async checkHealth() {
    try {
      const response = await apiClient.get('/health');
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Health check failed',
      };
    }
  },

  /**
   * Send password-reset email. Uses POST /api/auth/password-reset per AuthService spec.
   */
  async forgotPassword(email, continueUrl = null) {
    try {
      const body = { email };
      if (continueUrl) body.continueUrl = continueUrl;

      const response = await apiClient.post('/password-reset', body);
      const data = response.data || {};
      return {
        success: data.success !== false,
        data: { message: data.message, email: data.email },
        error: data.message && !data.success ? data.message : null,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Failed to send reset link',
      };
    }
  },
};
